import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "@/App";
import { router } from "@/router";

import "@/style.css";

import PostHogAnalyticsProvider from "@/providers/analytics/PostHogAnalyticsProvider";
import WorkOSAuthProvider from "@/providers/auth/WorkOSAuthProvider";
import ThemeProvider from "@/providers/theme/ThemeProvider";

import AuthenticatedQueryClientProvider from "@/api/query";

import { IS_DEBUG } from "@/constants";

const TanStackRouterDevtools = IS_DEBUG
  ? React.lazy(() =>
      import("@tanstack/react-router-devtools").then((res) => ({
        default: res.TanStackRouterDevtools,
      })),
    )
  : () => null;

const TanStackQueryDevtools = IS_DEBUG
  ? React.lazy(() =>
      import("@tanstack/react-query-devtools").then((res) => ({
        default: res.ReactQueryDevtools,
      })),
    )
  : () => null;

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
const root = createRoot(rootElement);
root.render(
  <StrictMode>
    <WorkOSAuthProvider>
      <PostHogAnalyticsProvider>
        <AuthenticatedQueryClientProvider>
          <ThemeProvider>
            <App />
            <TanStackRouterDevtools router={router} />
            <TanStackQueryDevtools />
          </ThemeProvider>
        </AuthenticatedQueryClientProvider>
      </PostHogAnalyticsProvider>
    </WorkOSAuthProvider>
  </StrictMode>,
);
